"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("@mui/material/Button"));
var ShowVideoOrPlaylist_jsx_1 = __importDefault(require("./ShowVideoOrPlaylist.jsx"));
var Lang_js_1 = require("../../Lang.js"); // Add translation function import
var WatchPage = function (_a) {
    var _b = _a.domVideoLoaded, domVideoLoaded = _b === void 0 ? false : _b;
    var _c = (0, react_1.useState)(domVideoLoaded), hasDomLoaded = _c[0], setHasDomLoaded = _c[1];
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _d = (0, react_1.useState)(null), videoData = _d[0], setVideoData = _d[1];
    var _e = (0, react_1.useState)({}), playlistAcl = _e[0], setPlaylistAcl = _e[1];
    var playlistRef = (0, react_1.useRef)({});
    var setPlaylist = function (p) { playlistRef.current = p; };
    var _f = (0, react_1.useState)(null), brightcoveConfig = _f[0], setBrightcoveConfig = _f[1];
    var _g = (0, react_1.useState)(true), loading = _g[0], setLoading = _g[1];
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        var videoEl = document.getElementById("video-show");
        if (videoEl && !hasDomLoaded) {
            var domVideoDataJson = (_a = videoEl.dataset.video) !== null && _a !== void 0 ? _a : "{}";
            var domPlaylistDataJson = (_b = videoEl.dataset.group) !== null && _b !== void 0 ? _b : "{}";
            var domConfigJson = (_c = videoEl.dataset.config) !== null && _c !== void 0 ? _c : "{}";
            var parsedVideo = JSON.parse(domVideoDataJson);
            setVideoData(__assign(__assign({}, parsedVideo), { svod_subscription: (_d = parsedVideo === null || parsedVideo === void 0 ? void 0 : parsedVideo.svod_subscription) !== null && _d !== void 0 ? _d : false }));
            var thePlaylist = JSON.parse(domPlaylistDataJson);
            var theAcl_1 = {};
            if (thePlaylist && thePlaylist.videos) {
                thePlaylist.videos.forEach(function (vid) {
                    theAcl_1[vid.uniqid] = vid.access || { allowed: true };
                });
            }
            setPlaylist(thePlaylist);
            setPlaylistAcl(theAcl_1);
            setBrightcoveConfig(JSON.parse(domConfigJson));
            setHasDomLoaded(true);
            setLoading(false);
            return;
        }
    }, [hasDomLoaded]);
    if (loading) {
        return (react_1.default.createElement("div", { className: "video-loading-container" },
            react_1.default.createElement("div", { className: "video-spinner" }),
            react_1.default.createElement("p", { className: "video-loading-text" }, "Loading video details...")));
    }
    if (!videoData) {
        return (react_1.default.createElement("div", { className: "video-error-container" },
            react_1.default.createElement("div", { className: "video-error-icon" }, "!"),
            react_1.default.createElement("h3", { className: "video-error-title" }, "Unable to load video"),
            react_1.default.createElement("p", { className: "video-error-message" }, (0, Lang_js_1.__)('Error loading video details. Please try again later.')),
            react_1.default.createElement(Button_1.default, { className: "video-error-retry", variant: "contained", onClick: function () { return window.location.reload(); }, sx: {
                    backgroundColor: '#e50914',
                    color: 'white',
                    padding: '0.6rem 1.5rem',
                    borderRadius: '4px',
                    fontWeight: 500,
                    '&:hover': { backgroundColor: '#f40612' },
                } }, "Retry")));
    }
    return (react_1.default.createElement(ShowVideoOrPlaylist_jsx_1.default, { navigate: navigate, videoData: videoData, playlist: playlistRef.current, playlistAcl: playlistAcl, brightcoveConfig: brightcoveConfig, resultsSearch: location.search, isSeminarLeader: videoData === null || videoData === void 0 ? void 0 : videoData.is_seminar_leader }));
};
exports.default = WatchPage;
